import { render, staticRenderFns } from "./eventSettingPage.vue?vue&type=template&id=77981635&"
import script from "./eventSettingPage.vue?vue&type=script&lang=ts&"
export * from "./eventSettingPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports